import React from 'react'
import Slider from "react-slick";


export default function MainSlider() {
  const settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"
  };
  
  return (
    <>
    <div className="row g-0 mt-4 mb-5">
      <div className="col-md-9 mainSlider">
      <Slider {...settings}>
       <img className='w-100' height={250} src={require('../../assets/images/slider-2.jpeg')} alt="Main Slider"  />
       <img className='w-100' height={250} src={require('../../assets/images/slider-image-1.jpeg')} alt="Main Slider"  />
       <img className='w-100' height={250} src={require('../../assets/images/slider-image-2.jpeg')} alt="Main Slider"  />
       <img className='w-100' height={250} src={require('../../assets/images/slider-image-3.jpeg')} alt="Main Slider"  />
    </Slider>
      </div>
      <div className="col-md-3">
        <img className='w-100' height={125} src={require('../../assets/images/grocery-banner.png')} alt="Show" />
        <img className='w-100' height={125} src={require('../../assets/images/grocery-banner-2.jpeg')} alt="Show" />
      </div>
    </div>
    
    </>
  )
}
